import React from 'react';
import { useConfigStore, useCustomComponent } from '@/hooks';
import { Text } from '../../ui';

export interface QuestionnaireSubmitTextProps {
  isFormSubmitting: boolean;
}

const SubmitText: React.FC<QuestionnaireSubmitTextProps> = ({
  isFormSubmitting,
}) => {
  const {
    features: {
      chat: {
        submitButton: { text, loadingText },
      },
    },
  } = useConfigStore();

  return (
    <Text size="lg" color="themePrimary" weight="normal">
      {isFormSubmitting ? loadingText : text}
    </Text>
  );
};

export const SubmitTextComponent: React.FC<QuestionnaireSubmitTextProps> = (
  props: QuestionnaireSubmitTextProps
) => {
  const Component = useCustomComponent({
    componentName: 'QuestionnaireSubmitText',
    Component: SubmitText,
  });
  return <Component {...props} />;
};
